import EventBus from './eventbus.js';

export default EventBus();
